import { useQuery } from "@tanstack/react-query";
import {
  fetchSubscriptionTemplates as fetchSubscriptionTemplatesApi,
  fetchSubscriptionTemplateById as fetchSubscriptionTemplateByIdApi,
} from "@/helpers/apis";
import { QUERY_OPTIONS } from "@/pages/subscriptions/services/queryConfig";

// Fetch all templates using global API
// Zod validation is handled by api.get in apis.ts (via patchWithZodSchema)
export const useTemplatesV2 = () => {
  return useQuery({
    queryKey: ["templates-v2"],
    queryFn: fetchSubscriptionTemplatesApi,
    ...QUERY_OPTIONS.reference,
  });
};

// Fetch a single template by ID using global API
export const useTemplateById = (templateId?: string) => {
  return useQuery({
    queryKey: ["template-v2", templateId],
    queryFn: () => fetchSubscriptionTemplateByIdApi(templateId!),
    enabled: !!templateId,
    ...QUERY_OPTIONS.reference,
  });
};
